module.exports = __webpack_public_path__ + "img/CM-PW-24-Kia-Playful.4ae405db.jpg";